<template>
  <div>
    <CCard>
      <ProcessBarModal
          :show-modal="showModal"
          :step="step"
          :error-text="downloadError"
          :progress="progress"
          :steps-text="{creating: 'Report creation', success: 'Report created', error: 'Something went wrong'}"
          @close="() => showModal = false"
          :title="$t('Downloading file')"
      />
      <CCardHeader>
        {{ $t('Reports') }}
      </CCardHeader>
      <CCardBody>
        <CRow class="w-100">
          <ul>
            <li v-for="link in links" v-if="shouldShowLink(link.label)">
              <CButton
                  color="link"
                  class="font-2xl custom-links"
                  @click="downloadFile(link.report)"
              >
                {{ $t(`${link.label}`) }}
                {{ link.sub_label ? link.sub_label : '' }}
              </CButton>
            </li>
          </ul>
        </CRow>
      </CCardBody>
    </CCard>
  </div>

</template>

<script>
import {GENERAL_DATA_REPORTS_ENDPOINTS} from "@/services/general_data_reports";

import Task from "@/services/task";
import ProcessBarModal from "@/components/ProcessBarModal.vue";
import { request } from "@/utils/request";

export default {
  name: "Reports",
  components: {ProcessBarModal},
  data() {
    return {
      showModal: false,
      step: '',
      progress: 0,
      downloadError: '',
      GENERAL_DATA_REPORTS_ENDPOINTS,

      isClosed: false,
      linksToHideOnClose: [
        "Control report", "Statistics report"
      ],
      links: [
        {
          label: "Compilation Annexe II",
          report: 'compilation_annexe_ii'
        },
        {
          label: "Compilation Annexe I et Annexe III",
          report: 'compilation_annexe_i_annexe_iii'
        },
      ]
    }
  },
  computed: {
    formattedDate() {
      return new Date().toJSON().slice(0, 10).replace(/-/g, "-");
    },
  },
  async mounted() {
  },
  methods: {
    shouldShowLink(name) {
      if (this.linksToHideOnClose.includes(name)) {
        return this.isClosed
      }
      return true;
    },
    async downloadFile(selected_report) {
      this.downloadError = '';
      this.step = 'creating'
      this.progress = 0;
      this.showModal = true;

      this.progress = 25
      const { data } = await request({
        url: this.GENERAL_DATA_REPORTS_ENDPOINTS.reports,
        query: {
          selected_report,
          language: this.$store.state.language
        }
      });
      this.progress = 50;
      if (data && !data.detail) {
        console.log("data", data)
        this.progress = 75;
        const task = new Task(data, 'xlsx');
        task.on('result', (result) => {
          if (result?.error) {
            this.step = 'error'
            this.uploadError = result.error
          }
          this.progress = 100;
          this.step = 'success';
          this.$downloadFile({ response: result })
        })

        task.on('error', (error) => {
          this.step = 'error'
          this.downloadError = error
        })
      }
      else {
        this.step = 'error'
        this.downloadError = data.detail || ''
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";

.custom-links {
  color: $primary;
  text-decoration: underline;

  &:hover {
    color: $text-secondary;
  }
}
</style>
